<div mat-dialog-title>
  <span>{{isEdit ? 'Edit User' : 'Create New User'}}</span>
</div>
<div mat-dialog-content>
  <form #f="ngForm" class="d-flex flex-column mt-1"> <!--toni I added mt- class because it was being choped off on top-->
    <mat-form-field floatLabel="always" color="primary" appearance="outline">
      <mat-label>Email</mat-label>
      <input [disabled]="isEdit" name="username" email matInput required [(ngModel)]="user.email"/>
    </mat-form-field>
    <mat-form-field floatLabel="always" color="primary" appearance="outline">
      <mat-label>Name</mat-label>
      <input name="name" matInput required [(ngModel)]="user.name"/>
    </mat-form-field>
    @if (!isEdit) {
      <mat-form-field floatLabel="always" color="primary" appearance="outline">
        <mat-label>Password</mat-label>
        <input name="password" matInput required
          [type]="hidePassword ? 'password' : 'text'"
          [(ngModel)]="user.password"
          [pattern]="passwordPattern"
          autocomplete="new-password"/>
        <button type="button" mat-icon-button matSuffix
          (click)="hidePassword = !hidePassword"
          [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
          [matTooltip]="hidePassword ? 'Show password' : 'Hide password'">
          <i class="fas" [ngClass]="hidePassword ? 'fa-eye' : 'fa-eye-slash'"></i>
        </button>
      </mat-form-field>
    }
    <mat-form-field floatLabel="always" color="primary" appearance="outline">
      <mat-label>Roles</mat-label>
      <mat-select name="roles" [multiple]="true" [(ngModel)]="user.roles" [disabled]="disabled" required>
        @for (dp of userRoleKL; track dp) {
          <mat-option [value]="dp.key">{{dp.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isPublisher()) {
      <div class="">
        <ctv-publisher-autocomplete-chips [publisherIds]="user.publisherIds"
          (publisherSelectionChange)="onPublisherSelection($event)"
          [networkIds]="[networkId]"
          [networkIdsChanged]="eventsSubjectNetwork.asObservable()"
          [clearItems]="clearFilterItems.asObservable()"
          [required]="isPublisher()"
          formFieldAppearance="outline">
        </ctv-publisher-autocomplete-chips>
      </div>
    }
    @if ((user.contentOwnerIds && user.contentOwnerIds.length && !userType) || (userType && user.contentOwners)) {
      <div class="">
        <ctv-content-owner-autocomplete-chips [contentOwners]="user.contentOwners"
          (contentOwnerSelectionChange)="onContentOwnerSelection($event)"
          [disabled]="disabled"
        formFieldAppearance="outline"></ctv-content-owner-autocomplete-chips>
      </div>
    }
    @if (needsAdvertiserAssignment()) {
      <div class="">
        <ctv-advertiser-autocomplete-chips-input
          [preselectedAdvertiserIds]="user.advertiserIds"
          (advertiserSelectionChange)="onAdvertiserSelection($event)"
          [required]="requiresAdvertiserIds()"
          label="Advertisers"
          formFieldAppearance="outline">
        </ctv-advertiser-autocomplete-chips-input>
      </div>
    }
  </form>
</div>
<div mat-dialog-actions class="user-editor-dialog__actions">
  <button mat-stroked-button class="mr-2" [mat-dialog-close]="false">
    Close
  </button>
  @if (!isEdit) {
    <button type="button" mat-flat-button class="iconed user-editor-dialog__generate" (click)="generatePassword()">
      <i class="fas fa-lock" aria-hidden="true"></i>
      <span>Generate Password</span>
    </button>
  }
  <button mat-flat-button *csHasPermission="RolePermission.USERS_CREATE" class="iconed" color="primary"
          [disabled]="!f.valid || (user && user.roles && user.roles.includes(userRole.PUBLISHER)
                && (!user.publisherIds || !user.publisherIds.length) || moreThanOneMainRoleSelected())
                || (requiresAdvertiserIds() && (!user.advertiserIds || !user.advertiserIds.length))"
    (click)="createUser()">
    <i class="fas fa-save"></i>
    <span>Save</span>
  </button>
</div>
